import { render, staticRenderFns } from "./DocumentDownloadPopup.vue?vue&type=template&id=1252b160&"
import script from "./DocumentDownloadPopup.vue?vue&type=script&lang=js&"
export * from "./DocumentDownloadPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports